import React from "react";

import ButtonLink from "../../../../base/links/button_link.js";

import { withStyles } from '@material-ui/styles';
import withCurrentUser from '../../../../hocs/with_current_user.js';
import withShowToast from '../../../../hocs/with_show_toast.js';
import withLocationSearchFilter from '../../../../hocs/with_location_search_filter.js';
import { compose } from 'redux';

import pageStyles from "../../../styles/page_styles.js";

import ListPageUseCase from "../../../../use_cases/admin/frontend/pages/list_pages_use_case.js";
import { AdminPageModel } from "../../../../models/frontend/admin/page_model.js";

import BaseListPage from "../../base_list_page.js";

import Routes from "../../../routes.js";

const styles = theme => ({
});

class PagesListPage extends BaseListPage {

  headerContent() {
    const { classes } = this.props;
    return <React.Fragment>
      <ButtonLink className = { classes.button }
                  to = { Routes.page("new") } >
        { I18n.t("admin.frontend.page.action.new") }
      </ButtonLink>
    </React.Fragment>
  }

}

PagesListPage.defaultProps = {
  dataModel: AdminPageModel,
  listUseCase: ListPageUseCase
}

export default compose(
  withLocationSearchFilter,
  withShowToast, 
  withCurrentUser, 
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(PagesListPage);
